import {NamedItem} from '../pipes/array-name-join.pipe';

/** A Soprism project in a `PlatformFolder`: what a folder card and the folder tree show of it. */
export interface PlatformFolderProject {
  id: number;
  name: string;
}

/**
 * A folder the Audiense platform keeps (Folders), as the dashboard shows it.
 * It lists its Soprism projects, like a Soprism `Folder`, so the same cards and
 * tree render it; it only counts the reports it holds from other products,
 * which the dashboard cannot show and the platform can (`platformUrl`). Writes
 * happen on the platform, never here.
 */
export class PlatformFolder implements NamedItem {
  /** Tells it apart from a Soprism `Folder` wherever both are listed. */
  readonly onPlatform = true;
  /** Never a Custom Folder: those stay in Soprism. */
  readonly flag = undefined;

  constructor(
    readonly id: string,
    public name: string,
    /** Kept in step locally as projects are added or removed, like a Soprism folder's. */
    public projects: PlatformFolderProject[],
    readonly otherProductsCount: number,
    readonly platformUrl: string,
    readonly created_at: Date,
    readonly updated_at: Date
  ) {}

  get projectIds(): number[] {
    return this.projects.map(project => project.id);
  }
}

export function isPlatformFolder(folder: unknown): folder is PlatformFolder {
  return folder instanceof PlatformFolder;
}
